import React from "react";
import ContentLoader from "react-content-loader";
import { useDispatch, useSelector } from "react-redux";
import { convertToKebabCase } from "../../../utils/common";
import { useNavigate } from "react-router-dom";

export const Popular = () => {
  const popular = useSelector((state) => state.listing.popular);
  const navigate = useNavigate();

  // Content loader for skeleton screen
  const loaders = Array.from({ length: 4 }, (_, index) => (
    <ContentLoader
      key={index}
      speed={1}
      width="100%"
      height="19rem"
      viewBox="0 0 195 205"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect rx="20" ry="20" width="100%" height="100%" />
    </ContentLoader>
  ));

  const handleClick = (data) => {
    navigate(
      `/category/${data.service_type_code}/${convertToKebabCase(
        data.service_name
      )}/${data.service_code}`
    );
  };

  return (
    <div>
      <div className="py-4 flex justify-between items-center">
        <p className="text-base font-semibold">Popular</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
        {/* Displaying loading skeleton */}
        {popular?.length === 0
          ? loaders
          : popular.map((data, i) => (
              <div
                key={i}
                className="cursor-pointer relative w-full flex flex-col"
              >
            <div className="w-full h-60 relative overflow-hidden mb-2 rounded-3xl group">
              <img
                draggable="false"
                onClick={() => handleClick(data)}
                alt={data.title}
                src={data.cover_img}
                className="w-full h-full object-cover  rounded-3xl transition-transform duration-300 ease-in-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-3xl pointer-events-none" />
            </div>

                <div
                  className="flex flex-col w-full"
                  onClick={() => handleClick(data)}
                >
                  <div className="line-clamp-1 text-base font-semibold text-primary-500 mt-2">
                    {data.title}
                  </div>
                  <div className="text-sm text-primary-500">
                    {data.theme !== "" ? data.theme : "Any Event"}
                  </div>
                  <div className="text-sm line-clamp-1">{data.location}</div>
                  <div className="text-sm">
                    PHP {data.service_price} for {data.pax > 0 ? data.pax : '∞'} guests
                  </div>
                  {Number(data.review_count) > 0 && (
                    <div className="text-xs underline text-primary-400 cursor-pointer">
                      {data.review_count} ribbon
                      {Number(data.review_count) > 1 ? "s" : ""}
                    </div>
                  )}
                </div>
              </div>
            ))}
      </div>
    </div>
  );
};
